import React, { useContext, useEffect, useState } from 'react';
import { Card, Button, Spinner, Form, Modal, Col, Row } from 'react-bootstrap';
import { useContextInfo } from '../../../context/ContextInfo';
import { useForm } from '../../../hooks/useForm';
import { fetchConToken } from '../../../api/fetch';
import { AuthContext } from '../../../auth/AuthContext';
import { useParams } from 'react-router-dom';
const initialState = {
    id: '',
    asunto: '',
    mensaje: '',
    tipo: '1',
};
const ModNotas = ({ show, onClose, data, callBk }) => {
    const { id } = useParams();
    const { auth } = useContext(AuthContext);

    let idR = atob(id);
    const [validated, setValidated] = useState(false);
    const [load, setLoad] = useState(false);
    const { setResp } = useContextInfo();
    const [values, handleInputChange, setFormValue] = useForm(initialState);
    useEffect(() => {
        setFormValue({ ...initialState, ...data });
    }, [data]);
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            const res = await fetchConToken('usertools/notas', { ...values, idcl: idR, ida: auth.uid }, 'PUT');
            setResp(res);
            callBk();
            setLoad(false);
            if (res.ok) onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">Nota</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Asunto</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.asunto}
                                                name="asunto"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Label>Mensaje</Form.Label>
                                            <Form.Control
                                                as={'textarea'}
                                                type="text"
                                                value={values.mensaje}
                                                name="mensaje"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustom022">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Select
                                                value={values.tipo}
                                                name="tipo"
                                                required
                                                onChange={handleInputChange}>
                                                <option value="1">Normal</option>
                                                <option value="2">Importante</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModNotas;
